import { onBeforeMount, reactive, ref } from "vue";
import { UseScrollView, UseScrollViewModel } from "./type";
import { useLoading } from "@/common/util/useLoading";

export const useScrollView = <T extends object>(option?: UseScrollView<T>) => {
    const [, handler] = useLoading(); 
    const list = ref<Array<T>>([]);
    const loading = ref(false);
    const refreshing = ref(false);
    const error = ref(false);

    const model = reactive<UseScrollViewModel<T>>({
        pageSize: option?.initPageSize || 30,
        pageIndex: 1,
        finished: false,
        // 不存在走系统默认的动态列表,上拉加载等功能都不需要
        system: !!option,
    });

    const onNextLoading = async () => {
        await handler(async () => {
            try {
                if (model.finished) return Promise.resolve([]);
                loading.value = true;
                error.value = false;
                const res = await option?.api({
                    pageSize: model.pageSize,
                    pageIndex: model.pageIndex,
                });
                const data = res || [];
                model.pageIndex += 1;
                list.value.push(...data as any);
                model.finished = (data || []).length < model.pageSize
                return data;
            } catch(e) {
                error.value = true;
            } finally {
                loading.value = false;
            }
        });
    };

    const onRefresh = async () => {
        await handler(async () => {
            try {
                model.pageIndex = 1;
                refreshing.value = true;
                error.value = false;
                const res = await option?.api({
                    pageSize: model.pageSize,
                    pageIndex: model.pageIndex,
                });
                const data = res || [];
                list.value = data as any;
                model.pageIndex += 1;
                model.finished = (data || []).length < model.pageSize
                return data;
            } catch(e) {
                error.value = true;
            } finally {
                refreshing.value = false;
            }
        });
    };

    onBeforeMount(onNextLoading);

    const method = {
        onRefresh,
        onNextLoading,
    };

    return {
        model,
        loading,
        refreshing,
        error,
        list,
        method,
    };
    
};

export default {
    useScrollView,
};